import React from 'react';

// eslint-disable-next-line react/prop-types
export default function Heading({ content }) {
  return (
    <div>
      <h1 className="heading-spacing f-f-b text-[50px] ">{content}</h1>
    </div>
  );
}
